export default __webpack_public_path__ + "aaa6c7f64479a9a1d20092f2ea9e1de8.png";